var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.prefix)}}),_c('span',{domProps:{"innerHTML":_vm._f("durationNoSemicolons")(_vm.currentElapsed)}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.suffix)}})])}
var staticRenderFns = []

export { render, staticRenderFns }